module.exports = __webpack_public_path__ + "static/media/RI-D6-0.1-063.58b7b8b0.webp";